/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import React from 'react';
import 'svgxuse';
import { WithSiteTracking } from 'react-event-tracker';
import { initTealium } from 'latitude-analytics';
import { siteData, schema, applyRules } from './tealium';
import PageContextProvider from '@/context/PageContext';
import { sourcePromoCodeHandler } from './src/utils/sourcePromoCodeHandler';
export const onClientEntry = async () => {
  // need to import a polyfill for Intersection Observer to be used in IE11
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`);
  }
  // to support URL api in IE11
  if (typeof URL !== 'function') {
    await import('url-polyfill');
  }
};


// pass all query params when navigating to loans portal link
  const targetLoansPortalURL =
    'https://loans.portal.gemfinance.co.nz/quote';

  const appendParamsToAnchor = (anchor) => {
      const src = new URL(window.location.href);
      const dest = new URL(anchor.href, window.location.href);

      src.searchParams.forEach((value, key) => {
            dest.searchParams.set(key, value);
      });

      anchor.href = dest.href;
  };

  const onClickHandler = (e) => {
    const anchor = e.target?.closest?.('a[href]');
    if (!anchor) return;
    if (!anchor.href.startsWith(targetLoansPortalURL)) return;
    appendParamsToAnchor(anchor);
    
  };

  document.addEventListener('click', onClickHandler, true);
  // end loans portal params


const passQueryParamsToLoansPortal = (link) => {
  const currentURL = new URL(window.location.href);
  const destinationURL = new URL(link.href);

  // Pass all query params from the current page URL
  currentURL.searchParams.forEach((value, key) => {
    destinationURL.searchParams.set(key, value);
  });

  window.open(destinationURL.toString(), "_blank");
};

export const onRouteUpdate = () => {
  // Replace this with your specific external URL or a pattern
  
  const targetExternalURL = "https://cards.gemvisa.co.nz/";

  const links = document.querySelectorAll(`a[href^='${targetExternalURL}']`);
  

  links.forEach((link) => {
    // Attach click handler
    link.addEventListener("click", (e) => {
      e.preventDefault(); // prevent default navigation

      // Modify URL using your handler
      const newURL = sourcePromoCodeHandler(link.href);

      // Open in new tab (or same tab if you prefer)
      window.open(newURL, "_blank");
    });
  });

  // Loans portal logic
  const targetLoansPortalURL =
    "https://loans.portal.gemfinance.co.nz/quote";

  const loanLinks = document.querySelectorAll(
    `a[href^='${targetLoansPortalURL}']`
  );

  loanLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      passQueryParamsToLoansPortal(link);
    });
  });
};

const trackingConfig = initTealium({ siteData, schema, applyRules });

export const wrapRootElement = ({ element }) => (
  <WithSiteTracking {...trackingConfig}> <PageContextProvider>{element}</PageContextProvider></WithSiteTracking>
);
